import React from 'react';
import { Link, Stack, Typography } from '@mui/material';
import TelegramBg from '../../assets/icons/telegram-bg.webp';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import useLocalization from '../../hooks/useLocalization';

const BalanceContact: React.FC = () => {
  const { t } = useLocalization();
  return (
    <Stack
      sx={{
        background: `url(${TelegramBg}) no-repeat`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        cursor: 'pointer',
        borderRadius: 2,
      }}
    >
      <Link
        href='https://t.me/slotpari'
        target='_blank'
        sx={{
          textDecoration: 'none',
          px: 2,
          py: 1,
        }}
      >
        <Typography
          variant='body1'
          component='h2'
          sx={{
            color: 'neutral.25',
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {t('letsBePartners')}
          <ArrowForwardIcon />
        </Typography>
        <Typography
          variant='body3'
          sx={{
            color: 'neutral.200',
          }}
        >
          {t('acceptPaymentWithUs')}
        </Typography>
      </Link>
    </Stack>
  );
};

export default BalanceContact;
